import { usePermission, type IPermissionCode } from "@/shared/permission";

/** The code behind every branch action, so a disabled control can name what is missing. */
export const BRANCH_PERMISSION_CODES = {
  add: "PRT_BRNCH_ADD",
  addr: "PRT_BRNCH_ADDR",
  edit: "PRT_BRNCH_EDIT",
  list: "PRT_BRNCH_LIST",
  detail: "PRT_BRNCH_DETAIL",
} as const satisfies Record<string, IPermissionCode>;

export function useBranchPermissions() {
  return {
    codes: BRANCH_PERMISSION_CODES,
    add: usePermission(BRANCH_PERMISSION_CODES.add),
    addr: usePermission(BRANCH_PERMISSION_CODES.addr),
    edit: usePermission(BRANCH_PERMISSION_CODES.edit),
    list: usePermission(BRANCH_PERMISSION_CODES.list),
    detail: usePermission(BRANCH_PERMISSION_CODES.detail),
  };
}

export type BranchPermissions = ReturnType<typeof useBranchPermissions>;
